@if (options?.mainButton) {
    <button
        #mainButton
        id="main-action-button"
        [class]="'btn standard-width main-container ' + options?.mainButtonClass"
        [disabled]="options?.mainButton.disabled"
        (click)="options?.mainButton.onPress()"
        [style.height.px]="options?.buttonHeight ?? 40"
    >
        <div class="content-container">
            @if (options?.mainButton?.faIconText) {
                <app-icon
                    [faIcon]="options.mainButton.faIconText"
                    class="button-icon"
                    [style.fontSize.px]="options?.mainButton?.iconFontSettings?.size ?? 16"
                    [style.color]="options?.mainButton?.iconFontSettings?.color"
                    [style.fontWeight]="options?.mainButton?.iconFontSettings?.weight ?? 200"
                />
            }
            <div
                class="text-container"
                [style.fontSize.px]="options?.mainButton?.textFontSettings?.size ?? 16"
                [style.color]="options?.mainButton?.textFontSettings?.color"
                [style.fontWeight]="options?.mainButton?.textFontSettings?.weight ?? 200"
                [style.lineHeight.px]="options?.mainButton?.textFontSettings?.lineHeight ?? 20"
                [style.textAlign]="options?.mainButton?.faIconText ? 'left' : 'center'"
            >
                {{ (options?.mainButton.textKey) | translate: options?.mainButton.translationParams }}
            </div>
        </div>
        
        @if (options?.dropdownButtons?.length) {
            <button
                [matMenuTriggerFor]="menu"
                #menuOpened="matMenuTrigger"
                (click)="$event.stopPropagation()"
                [disabled]="options?.dropdownDisabled || options?.mainButton?.disabled"
                class="dropdown-button"
                [ngClass]="{ 'opened': menuOpened.menuOpen }"
            >
                <app-icon *ngIf="!menuOpened.menuOpen" faIcon="fas fa-chevron-down" class="chevron-icon"/>
                <app-icon *ngIf="menuOpened.menuOpen" faIcon="fas fa-chevron-up" class="chevron-icon"/>
            </button>
        }
    </button>

    <mat-menu id="dropdown-menu" #menu="matMenu" xPosition="before" yPosition="below" class="dropdown-menu">
        <button
            mat-menu-item
            *ngFor="let item of options.dropdownButtons"
            [disabled]="item.disabled"
            (click)="item.onPress()"
            [style.minWidth.px]="mainButtonElement?.nativeElement?.offsetWidth"
        >
            @if (item?.faIconText) {
                <app-icon
                    [faIcon]="item?.faIconText"
                    class="button-icon"
                    [style.fontSize.px]="item?.iconFontSettings?.size ?? 16"
                    [style.color]="item?.iconFontSettings?.color"
                    [style.fontWeight]="item?.iconFontSettings?.weight ?? 200"
                />
            }
            <div
                class="text-container"
                [style.fontSize.px]="item?.textFontSettings?.size ?? 16"
                [style.color]="item?.textFontSettings?.color"
                [style.fontWeight]="item?.textFontSettings?.weight ?? 200"
                [style.textAlign]="item?.faIconText ? 'left' : 'center'"
                [style.lineHeight.px]="item?.textFontSettings?.lineHeight ?? 20"
            >
                {{ item.textKey | translate: item.translationParams }}
            </div>
        </button>
    </mat-menu>
}